import utils from "./Utils.js";
import plotMgrInstance from "./PlotMgr.js"
import * as d3 from "d3";
import {Plot} from "./Plot.js"

class DonutPlot extends Plot {

  constructor(initParams) {
    let _defaultParams = plotMgrInstance.parameters;
    _defaultParams.innerRadiusOfDonutChart = 0.3;
    _defaultParams.outerRadiusOfDonutChart = 0.9;
    _defaultParams.outlineColor = "white";
    let params = { ..._defaultParams, ...(initParams || {}) };
    super(params)
    this.innerRadiusOfDonutChart = params.innerRadiusOfDonutChart
    this.outerRadiusOfDonutChart = params.outerRadiusOfDonutChart
    this.outlineColor = params.outlineColor
  }

  addDonutPlot(newData, idForPlotCreation, keyForPlotCreation, layoutType, idKeyValue = undefined) {
    try {
      var scope = this;

      scope.plotKey = keyForPlotCreation;
      scope.keys.x = keyForPlotCreation;
      scope.keys.y = idKeyValue;

      var radius = Math.min(scope.canvas.offsetWidth, scope.canvas.offsetHeight) / 2.0;
      scope.canvas.innerHTML = "";
      let arc = d3.arc()
        .innerRadius(radius * scope.innerRadiusOfDonutChart)
        .outerRadius(radius * scope.outerRadiusOfDonutChart);

      let dataObj = {};
      let dataArr = [];
      
      // Create the donut plot layout for number or count layout type
      if (layoutType == 'value') {
        if (keyForPlotCreation == 'string' || keyForPlotCreation == 'bool') {
          error.textContent = "Failed to add donut plot for string using number layout type"
        }
        else {
          let response = utils.filterNumberTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
          if (response.status == 'success') {
            dataObj = response.data;
          }
        }
      }
      // Create the donut plot layout for string, bool and date datatype
      else {
        let response = utils.filterOtherTypeData(newData, idForPlotCreation, keyForPlotCreation, idKeyValue);
        if (response.status == 'success') {
          dataObj = response.data;
        }
      }

      dataArr = dataObj.data;

      dataArr.forEach(element => {
        scope.data[element.key] = element;
        element.ids.forEach(id => {
          scope.elements[id] = element.key;
        });
      });

      let pie = d3.pie()
        .value(function (d) { return d.value; })
        .sort(null);


      let dimensions = "0 0 " + scope.canvas.offsetWidth + " " + scope.canvas.offsetHeight;

      let plotContainer = d3.select(scope.canvas).append("svg")
        .attr("viewBox", dimensions)
        .attr("preserveAspectRatio", "xMinYMin meet");

      // utilsInstance.partialFillPattern(plotContainer,this.selectionColor); 

      let plotCanvas = plotContainer
        .append("g")
        .attr("transform", "translate(" + scope.canvas.clientWidth / 2 + "," + scope.canvas.clientHeight / 2 + ")");

      scope.tooltip = d3.select(scope.canvas).append("div");
      utils.formatTooltipDefault(scope.tooltip, scope.defaultColor);

      // Define inner circle
      plotCanvas.append("circle")
        .attr("cx", 0)
        .attr("cy", 0)
        .attr("opacity", scope.highlightOpacity)

      // Calculate SVG paths and fill in the colours
      scope.svg = plotCanvas.selectAll(".arc")
        .data(pie(dataArr))
        .enter().append("g")
        .attr("class", "arc")
        .attr("data-id", function (d, i) {
          scope.groups[d.data.key] = this;
          return d.data.key;
        })

      // Append the path to each g
      scope.svg.append("path")
        .attr("d", arc)
        .attr("fill", scope.defaultColor)
        .attr("stroke", scope.outlineColor) // outline for each region
        .attr("data-isSel", false)
        .attr("data-isPar", false)
        .attr("data-isClr", false)
        .attr("data-color", scope.defaultColor)
        .attr("data-id", function (d, i) { return d.data.key; })
        .on("mouseover", function (d) { utils.formatTooltipOn(scope.tooltip) })
        .on("mouseleave", function (d) { utils.formatTooltipOff(scope.tooltip) })

      let plotLabels = plotCanvas.selectAll(".labels")
        .data(pie(dataArr))
        .enter().append("g")
        .attr("class", "labels")
        .style("pointer-events", "none") // resrticted mouse events

      // Append text labels to each arc
      plotLabels.append("text")
        .attr("transform", function (d) {
          var r = utils.computeTextRotation(d);
          var transforms = "translate(" + arc.centroid(d) + ") ";
          transforms += "rotate(" + (r.global - r.correction) + ")";
          return transforms;
        })
        .attr("dy", ".35em")
        .style("text-anchor", "middle")
        .style("font-size", "10px")
        .attr("fill", scope.labelColor)
        .text(function (d, i) {
          if (typeof (d.data.key) == 'number') {
            return utils.setDigits(d.data.key, scope.digits);
          }
          else {
            return d.data.key;
          }
        });

      let returnValue = {
        "status": "success",
        "message": "Donut plot added"
      }
      scope.plotAdded = true
      return returnValue;
    }
    catch (err) {
      let returnValue = {
        "status": "failed",
        "message": "Failed to add donut plot." + err.message
      }
      return returnValue;
    }
  }

  resizeChart() {
    let scope = this;

    // Get new dimensions
    let newWidth = scope.canvas.offsetWidth
    let newHeight = scope.canvas.offsetHeight - scope.margin.top - scope.margin.bottom
    let newRadius = Math.min(newWidth, newHeight) / 2.0;

    // Update SVG dimensions
    d3.select(scope.canvas).select("svg")
      .attr("viewBox", `0 0 ${scope.canvas.offsetWidth} ${scope.canvas.offsetHeight}`);

    // Update the arc generator with the new radius
    let arc = d3.arc()
      .innerRadius(newRadius * scope.innerRadiusOfDonutChart)
      .outerRadius(newRadius * scope.outerRadiusOfDonutChart);

    // Update the transform for the main group
    d3.select(scope.canvas).select("svg").select("g")
      .attr("transform", `translate(${newWidth / 2}, ${newHeight / 2})`);

    // Update the arcs with the new arc generator
    d3.select(scope.canvas).selectAll(".arc path")
      .attr("d", arc);

    // Update the text labels
    d3.select(scope.canvas).selectAll(".labels text")
      .style("font-size", function() {
        let minDimension = Math.min(newWidth, newHeight)
        if (minDimension < 150) return "8px"
        else return "10px"; // Example: Set a fixed font size of 10px
      })
      .attr("transform", function (d) {
        var r = utils.computeTextRotation(d);
        var transforms = "translate(" + arc.centroid(d) + ") ";
        transforms += "rotate(" + (r.global - r.correction) + ")";
        return transforms;
      });
  }

  //  ████  ███  █      ███  ████  ████  █   █ 
  // █     █   █ █     █   █ █   █ █   █  █ █  
  // █     █   █ █     █   █ ████  ████    █   
  // █     █   █ █     █   █ █   █ █   █   █   
  //  ████  ███  █████  ███  █   █ ████    █   


  getHighlightedElement(group){
    return d3.select(group.childNodes[0])
  }


  // █████ █████ █     █████  ████ █████ 
  // █     █     █     █     █       █   
  // █████ ████  █     ████  █       █   
  //     █ █     █     █     █       █   
  // █████ █████ █████ █████  ████   █   



  selectElements(elementIDs) {
    let scope = this;

    let selectedElement = [];
    if (scope.svg != undefined) {
      for (let i = 0; i < scope.svg._groups[0].length; i++) {
        let counter = 0;
        let elementID = scope.svg._groups[0][i].__data__.data.ids;
        for (let j = 0; j < elementIDs.length; j++) {
          for (let k = 0; k < elementID.length; k++) {
            if (elementID[k] == elementIDs[j]) { counter++; }
          }
        }
        if (counter == elementID.length) {
          selectedElement = scope.svg._groups[0][i]
          if (selectedElement.className['baseVal'] == 'arc') {
            let element = d3.select(selectedElement.childNodes[0])
            if (element != undefined) {
              if (scope.svg != selectedElement.childNodes[0]) {
                scope.applySelectionColor(element);
              }
            }
          }
        }
        else if (counter > 0 && counter <= elementIDs.length) {
          selectedElement = scope.svg._groups[0][i]
          if (selectedElement.className['baseVal'] == 'arc') {
            let element = d3.select(selectedElement.childNodes[0])
            if (element != undefined) {
              if (scope.svg != selectedElement.childNodes[0]) {
                scope.applyPartialSelectionColor(element);
              }
            }
          }
        }
      }
    }
  }

  // █   █ █████  ████ █   █ █     █████  ████ █   █ █████ 
  // █   █   █   █     █   █ █       █   █     █   █   █   
  // █████   █   █  ██ █████ █       █   █  ██ █████   █   
  // █   █   █   █   █ █   █ █       █   █   █ █   █   █   
  // █   █ █████  ███  █   █ █████ █████  ███  █   █   █   


  getElementToHighlight(key){
    let scope = this;
    return d3.select(scope.groups[key]).selectAll('*');
  }

  buildTooltipContent(id) {
    let scope = this;
    let content = "<strong>" + scope.data[id].key + "</strong> | " + scope.data[id].ids.length + " (" + utils.setDigits(scope.data[id].ids.length / Object.keys(scope.elements).length * 100.0, 2) + "%) <br/>";
    return content;
  }
}
export { DonutPlot }